import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export type MarginSchemeKindItemCode = 'MR_UZ' | 'MR_T' | 'MR_SZ' | 'MR_KOL';

export interface MarginSchemeKindItem {
    readonly id: number;
    readonly code: MarginSchemeKindItemCode;
    readonly name: string;
}

export class MarginSchemeKindQuery extends Query<MarginSchemeKindItem[]> { }

export class MarginSchemeKindQueryHandlerBase implements QueryHandler<MarginSchemeKindQuery, MarginSchemeKindItem[]> {
    private static Url = TaggedUrl.join('sales/marginSchemeKinds', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: MarginSchemeKindQuery): Promise<MarginSchemeKindItem[]> {
        const { data } = await this.http.get<{ items: MarginSchemeKindItem[]; }>(MarginSchemeKindQueryHandlerBase.Url);
        return data.items.map(i => ({
            id: i.id,
            code: i.code,
            name: i.name,
        }));
    }
}
